export default __webpack_public_path__ + "static/bg-finance-a96955f9e2e72abea930096e6dfb6cf3.webp";